export const signupFormLogic = {
    formFields: ['password'],
    regexError: false,
    nullError: false,
    password: {
        id: "password",
        className: "password",
        value: '',
        name: 'password',
        type: 'password',
        label: 'sign_up.password',
        required: true,
        maxLength: 64,
        dangerWarn: false,
        errorMessage: null,
        regex: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!#$%&'*+\\-/=?^_`{|}~.@])(?!.*[^!#$%&'*+\\-/=?^_`{|}~.@a-zA-Z0-9]).{8,64}$",
        showPassword: false,
        showPasswordIcon: true,
    }
}